import { Typography } from "@material-ui/core";

export function IVHeparinText(renalImpairmentLevel, overWeightLimit) {
    let text = [];
    text.push([<Typography variant="body1" style={{ marginTop: 20 }}>
                    <strong>IV HEPARIN</strong>
                </Typography>,
                <Typography variant="body2">
                    <p>
                    IV Heparin treatment dose and monitoring is to occur in accordance
                    with
                    </p>
                    <p>
                    <strong>
                        <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
                    </strong>
                    </p>
                </Typography>]); 
                
            if (overWeightLimit && renalImpairmentLevel != 'severe') {
                text.push([<Typography variant="body2">
                    <p>
                    If IV access is not possible or if enoxaparin is preferred by the treating team,
                    discuss use of enoxaparin with consultant prior to prescribing.
                    </p>
                </Typography>]);
            }
    return text;
}